import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { apiConsts } from 'src/api/apiConsts'
import { endpoints } from 'src/api/localities'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { MUIThemeColors } from 'src/mui-theme'
import { CustomersAdminTable } from 'src/screens/admin/customers/CustomersTable'
import { LocalitiesTable } from 'src/screens/customer/localities/LocalitiesTable'
import { getThemeColor } from 'src/utils'

const CustomerWithLocalities: React.FC = () => {
  const { t: translate } = useTranslation(['admin-customer', 'common'])
  const theme = useTheme()
  return (
    <CommonPageLayout titleSection={{ title: translate('customers') }}>
      <Box padding={'8px'} bgcolor={getThemeColor(theme, MUIThemeColors.white)} borderRadius={'4px'}>
        <CustomersAdminTable
          getDetailPanelContent={({ row }) => (
            <CommonPageLayout
              titleSection={{
                titleComponent: (
                  <Typography sx={{ color: getThemeColor(theme, MUIThemeColors.primaryMain), fontSize: '16px' }}>
                    {translate('localities', { ns: 'common' })}
                  </Typography>
                ),
              }}
              padding={2}
            >
              <Box border={1} borderRadius={'4px'} borderColor={getThemeColor(theme, MUIThemeColors.inputBorder)}>
                <LocalitiesTable
                  queryUrl={endpoints.getLocalities(row.id)}
                  customerId={row.id}
                  autoheight={true}
                  pageSize={apiConsts.PageSizeForSearch}
                />
              </Box>
            </CommonPageLayout>
          )}
        />
      </Box>
    </CommonPageLayout>
  )
}

export default CustomerWithLocalities
